































































import Vue from 'vue';
import VueMoment from 'vue-moment';
Vue.use(VueMoment);

export default Vue.extend({
  name: 'App',
  components: {},
  data: () => ({
    errorModal: false,
    errorText: '',
    errSnack: false,
    errMsg: '',
  }),
  watch: {
    '$store.state.globalMessage'() {
      if (this.$store.state.globalMessage !== '') {
        this.errMsg = this.$store.state.globalMessage;
        this.errSnack = true;
        this.$store.commit('globalMessage', '');
      }
    },
    '$store.state.globalErrorText'() {
      // Ak Err - Vyzaduje kompletny vypis/Neocakavany error
      if (this.$store.state.globalErrorText !== '') {
        this.errorText = this.$store.state.globalErrorText;
        this.errorModal = true;
        this.$store.commit('globalErrorText', '');
      }
    },
  },
  mounted() {
    this.$store
      .dispatch('checkLogin')
      .then(() => {
        // console.log('vsetko nacitasne');
      })
      .catch(() => {
        console.log('notLoggedIn');
      });
  },
  methods: {
    onResize() {
      this.$store.commit('windowSize', {
        x: window.innerWidth,
        y: window.innerHeight,
      });
    },
  },
});
